export default __webpack_public_path__ + "static/media/autoconsumo-individual-sin-excedentes-factura.be8e9874.png";